import LbToBR from "components/atom/LbToBr";
import { FC } from "react";
import { Review } from "../../../../../../api-schema/reviews";
import CategoryTags from "./CategoryTag";
import {
  useDisclosure,
  Button,
  Box,
  Stack,
  Spacer,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import ReviewContactForm from "./ReviewContactForm";

type ReviewCardProps = {
  review: Review;
  ContactButton?: React.FC;
};
export const ReviewCard: FC<ReviewCardProps> = ({ review, ContactButton }) => {
  const { time, star, review: body, ...categories } = review;

  return (
    <>
      <Box
        border="1px"
        borderColor="blackAlpha.200"
        borderRadius="lg"
        shadow="lg"
        rounded="lg"
        p={4}
      >
        <Stack spacing={4}>
          <Stack direction="row" alignItems="center">
            <span className="p-1">
              <span className="has-text-warning">{"★".repeat(star)}</span>
              <span>{"★".repeat(5 - star)}</span>
            </span>
            <span className="p-1 is-size-7">
              {time.toLocaleString().slice(0, -3)}
            </span>
            <Spacer />
            {ContactButton && <ContactButton />}
          </Stack>
          <div>
            <LbToBR text={body} />
          </div>
          <div>
            <CategoryTags categories={categories} />
          </div>
        </Stack>
      </Box>
    </>
  );
};
type ReviewCardWithContactFormModalProps = {
  review: Review;
};
const ReviewCardWithContactFormModal: FC<
  ReviewCardWithContactFormModalProps
> = ({ review }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <ReviewCard
        review={review}
        ContactButton={() => (
          <Button
            colorScheme="teal"
            variant="outline"
            onClick={onOpen}
            fontSize="x-small"
            padding="0.3rem"
          >
            ラベルの誤りを教える
          </Button>
        )}
      />
      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ラベルの誤りを教える</ModalHeader>

          <ModalCloseButton />
          <ModalBody>
            <ReviewContactForm review={review} onAfterSubmit={onClose} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default ReviewCardWithContactFormModal;
